<template>
  <LayoutShellFlat>
    <template #nav>
      <NavBarWorkspaceSettings />
    </template>
    <slot />
  </LayoutShellFlat>
</template>
